import { useGetFrontRichiesteV2IdComunicazioni } from '@framework/api-client/api/inquiries-compile/comunicazioni-v2/comunicazioni-v2.ts';
import { type GetFrontRichiesteV2IdComunicazioniParams } from '@framework/api-client/api/inquiries-compile/schemas/getFrontRichiesteV2IdComunicazioniParams.ts';
import {
  type CreateCommunicationRequest,
  CreateCommunicationRequestMapper,
} from '@framework/common-web/schema/communication/CreateCommunicationRequestSchema.ts';

interface IProps {
  submissionId: string | null | undefined;
  query: GetFrontRichiesteV2IdComunicazioniParams;
  selectedCommunication: CreateCommunicationRequest | null;
  setSelectedCommunication: (comunicazione: CreateCommunicationRequest) => void;
}

export function useCommunicationList(props: IProps) {
  const {
    submissionId,
    query,
    selectedCommunication,
    setSelectedCommunication,
  } = props;

  const result = useGetFrontRichiesteV2IdComunicazioni(
    submissionId ?? '',
    query,
    {
      query: {
        keepPreviousData: true,
        enabled: submissionId != null,
        onSuccess: ({ dati }) => {
          if (selectedCommunication !== null && dati && dati?.length > 0) {
            dati?.forEach(comunicazione => {
              comunicazione.id === selectedCommunication.idComunicazione &&
                setSelectedCommunication(
                  CreateCommunicationRequestMapper.requestToFormData(
                    comunicazione,
                  ),
                );
            });
          }
        },
      },
    },
  );

  const records = result?.data?.dati ?? [];
  const meta = result?.data?.meta;

  return {
    records,
    meta,
    isFetching: result.isFetching,
    isError: result.isError,
    error: result.error,
  };
}
